import { tKey } from 'ember-intl';
import type { CostBreakdownData } from 'lumen/utils/net-revenue/types';

export const COST_BREAKDOWNS = {
  CHANNEL: 'channel',
  MARKET_SEGMENT: 'marketSegment',
  COST_PROFILE: 'costProfile',
} as const;
export type CostBreakdown =
  (typeof COST_BREAKDOWNS)[keyof typeof COST_BREAKDOWNS];

export interface CostBreakdownOption {
  id: CostBreakdown;
  label: string;
}

export const DEFAULT_COST_BREAKDOWN: CostBreakdown =
  COST_BREAKDOWNS.MARKET_SEGMENT;

export const COST_BREAKDOWN_ORDER: CostBreakdown[] = [
  COST_BREAKDOWNS.CHANNEL,
  COST_BREAKDOWNS.MARKET_SEGMENT,
  COST_BREAKDOWNS.COST_PROFILE,
];

export const COST_BREAKDOWN_LABEL_KEYS: Record<CostBreakdown, string> = {
  [COST_BREAKDOWNS.CHANNEL]: tKey('net_revenue.breakdown_channel'),
  [COST_BREAKDOWNS.MARKET_SEGMENT]: tKey(
    'net_revenue.breakdown_market_segmentation',
  ),
  [COST_BREAKDOWNS.COST_PROFILE]: tKey('net_revenue.breakdown_cost_profile'),
};

// Unmapped bookings alone still count as content.
export function hasCostBreakdownContent(
  data: CostBreakdownData | undefined,
): boolean {
  return (data?.rows.length ?? 0) > 0 || data?.unmapped != null;
}

// The column names the rows, so Market segmentation's rows are "Market segment".
export const COST_BREAKDOWN_COLUMN_LABEL_KEYS: Record<CostBreakdown, string> = {
  [COST_BREAKDOWNS.CHANNEL]: tKey('net_revenue.breakdown_channel'),
  [COST_BREAKDOWNS.MARKET_SEGMENT]: tKey('general.market_segment'),
  [COST_BREAKDOWNS.COST_PROFILE]: tKey('net_revenue.breakdown_cost_profile'),
};

// Only Channel and Market segmentation point users to their mapping settings.
export const COST_BREAKDOWN_UNMAPPED_COPY: Record<
  CostBreakdown,
  { label: string; tooltip: string | null }
> = {
  [COST_BREAKDOWNS.CHANNEL]: {
    label: tKey('general.unmapped'),
    tooltip: tKey('net_revenue.unmapped_tooltip'),
  },
  [COST_BREAKDOWNS.MARKET_SEGMENT]: {
    label: tKey('general.unmapped'),
    tooltip: tKey('net_revenue.unmapped_tooltip'),
  },
  [COST_BREAKDOWNS.COST_PROFILE]: {
    label: tKey('net_revenue.remaining_reservations'),
    tooltip: null,
  },
};
